import React from "react";
import styles from "./styles.module.css";
import { Button } from "antd";
import { Link } from "react-router-dom";

const MiddleText = () => {
  return (
    <div className={styles.general}>
    <div className={styles.weDes}>
      <p className={styles.weDesT}>
        WE DESIGN <span className={styles.weDesTS}>TRENDS</span> OF THE{" "}
        <span className={styles.weDesTS}>FUTURE</span>, SO YOU’RE NEVER OUT OF{" "}
        <span className={styles.weDesTS}>STYLE</span>{" "}
      </p>
    </div>
    <div className={styles.weDesBc}>
    <Link to="/about">
      <Button className={styles.weDesB}>READ ABOUT US</Button>
    </Link>
    </div>
    </div>
  );
};

export default MiddleText;
